<div class="whatsapp_frame" [ngClass]="{'loading' : !frameLoadedFully}" [innerHTML]="iframe | sanitizeHtml">

</div>
